
import { SearchParamsType } from "../../Masters/insuranceMasters/InsurancePlan/Types";
import { ResponseType } from "../../Types/ServicesType/servicesType";
import { clinicList, editUserType, UserListType } from "./types";
import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import instance from "@services/services";
const {clinicId} = getConstants()

const {SettingsApi} = api
export const getAllUser = async (params:SearchParamsType):Promise<ResponseType<{items:UserListType[],totalCount:number}>>=>{
    const result = await instance.post(`${SettingsApi.getAllUser}`,params);
    return result.data;
}

export const saveUSer = async (params:editUserType[]):Promise<ResponseType<string | null>>=>{
    const result = await instance.post(`${SettingsApi.saveUser}`,params);
    return result.data;
}

export const updateStatusService=async(params:{id:number,status:number,clinicId:number}[]):Promise<ResponseType<string|null>>=>{
     const result = await instance.post(`${SettingsApi.updateSatus}`,params);
    return result.data;
}

export const getAllClincs =async(params:{clinicId:number,searchText:string}):Promise<ResponseType<clinicList[]>>=>{
    const result = await instance.post(`${SettingsApi.getAllClicnis}`,params);
    return result.data;
}
export const getAllemployees =async(params:{clinicId:number,searchText:string}):Promise<ResponseType<any>>=>{
    const result = await instance.post(`${SettingsApi.getEmployees}`,params);
    return result.data;
}
export const getUserGroups =async():Promise<ResponseType<any>>=>{
    const result = await instance.get(`${SettingsApi.getUserGroup}${clinicId}`);
    return result.data;
}

